import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UploadReqAddEditEndClientModalComponent } from './upload-req-add-edit-end-client-modal.component';

@NgModule({
  declarations: [UploadReqAddEditEndClientModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot()
  ],
  exports: [UploadReqAddEditEndClientModalComponent],
  entryComponents: [UploadReqAddEditEndClientModalComponent]
})
export class UploadReqAddEditEndClientModalModule { }
